import Cookies from "universal-cookie";
const cookie = new Cookies();

// Function sets a cookie by adding together the cookie name, cookie value
// and the expires string (date when it is supposed to expire)
// Parameters:
// name - name of the cookie
// value - value of the cookie
// exdays - number of days until the cookies should expire
export function setCookie(name: string, value: string, exdays: number) {
    if (!checkIfCookieExists(name)) {
        const date = new Date();
        date.setTime(date.getTime() + (exdays * 24 * 60 * 60 * 1000));
        cookie.set(name, value, {path: "/", expires: date});
    }
}

// Function that checks if a given cookie exists
// Parameter:
// name - name of the cookie
export function checkIfCookieExists(name: string) :boolean {
    const searchCookie = cookie.get(name);
    if (searchCookie && searchCookie !== "") {
        return true;
    } else {
        return false;
    }
}

// Function that remove cookies with this name
// Parameters:
// name - name of the cookie
export function removeCookie(name: string) {
    cookie.remove(name, {path: "/"});
}

// Function that shows all saved cookies
export function getAll() {
    return cookie.getAll();
}